import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  isOpen?: boolean;
}
export function Accordion({
  title,
  subtitle,
  children,
  isOpen: defaultOpen = false
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-zinc-800 rounded-xl overflow-hidden bg-zinc-900/50 mb-4 transition-all duration-300 hover:border-brand-pink/50" data-id="element-155">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 md:p-6 text-left bg-zinc-900 focus:outline-none" data-id="element-156">
        <div className="flex-1 pr-4" data-id="element-157">
          <h3 className="text-lg md:text-xl font-bold text-white leading-tight" data-id="element-158">
            {title}
          </h3>
          {subtitle && <p className="text-brand-pink text-sm md:text-base mt-1 font-medium" data-id="element-159">
              {subtitle}
            </p>}
        </div>
        <div className={`w-8 h-8 rounded-full bg-zinc-800 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 bg-brand-pink text-white' : 'text-zinc-400'}`} data-id="element-160">
          <ChevronDown className="w-5 h-5" data-id="element-161" />
        </div>
      </button>

      <div className={`transition-all duration-500 ease-in-out overflow-hidden ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-162">
        <div className="p-5 md:p-6 border-t border-zinc-800 bg-zinc-900/30 text-zinc-300 space-y-3" data-id="element-163">
          {children}
        </div>
      </div>
    </div>;
}